import { useRouteLoaderData } from 'react-router';
import { DeviceDetailsCoCo } from '../../../components/DeviceDetailsCoCo/DeviceDetailsCoCo.js';
import { PublicPageContent } from './PublicPath.js';
import type { PublicPageOrDeviceLoaderData } from '../../../common/loaders.js';

export const PublicPathCoCo = ({ children }: React.PropsWithChildren) => {
  const page = (useRouteLoaderData('public-path-root') ?? {}) as PublicPageOrDeviceLoaderData;
  if (page.deviceOfferData) {
    return <DeviceDetailsCoCo />;
  }
  return <PublicPageContent {...page}>{children}</PublicPageContent>;
};
